<template>
  <RouterView />
  <PageLoader />
  <PwaInstallPrompt />
</template>

<script setup lang="ts">
import { PageLoader, PwaInstallPrompt } from '@/components'
import { RouterView } from 'vue-router'
</script>
